export const PERMISSION_TYPES = {
  ACTION_MAPPINGS: 'DigitalAdvertising.AccountConfiguration.ActionMappings',
  SIGNAL_ACCESS: 'Signal.SignalPermissions.SignalAccess',
  SIGNAL_ACTIVATION: 'Signal.SignalPermissions.Activation',
  MERIDIAN_DASHBOARD: 'Meridian.Dashboard.MeridianDashboard',
  INDUSTRY_REPORT: 'Meridian.Industry.IndustryReport',
  DEALER_PRO: 'PureInsights.Reporting.DealerPro',
  MARKET_VIEW: 'PureInsights.Reporting.MarketView',
  PROSPECT_MARKET_VIEW: 'PureInsights.Reporting.ProspectMarketView',
  INVENTORY_CONFIGURATION_FEEDS:
    'Administration.Driver.InventoryConfigurationFeeds',
  RYLIE_AI_CHATBOT: 'PureInsights.Reporting.RileyAIChatBot',
  SALESFORCE_OPPORTUNITIES: 'Administration.Salesforce.ManageOpportunities',
  HUBSPOT_LIST_SYNC_TO_SALESFORCE:
    'Administration.Operations.HubSpotListSyncToSalesforce',
  VIRTUAL_DEALER_GROUPS: 'Administration.TenantAdmin.VirtualDealerGroups',
  AUDIENCE_MANAGEMENT:
    'AudienceManagement.AudienceManagementPermissionGroup.AudienceManagement'
}
